import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getZeroInDecimal } from '../../utils/price/get-zero-in-decimal';
import formatPrice from '../../utils/price/format-price';

type CurrencyPriceProps = {
    price?: Price;
    showZeroInDecimal?: boolean;
};

const CurrencyPrice: FC<CurrencyPriceProps> = (props) => {
    const { price, showZeroInDecimal = false } = props;

    const currency = useSelector((state: RootState) => state.main.currency);
    const convertedPrice = Number(String(price).replace(',', '.').replace(' ', ''));

    const formattedPrice = formatPrice(
        showZeroInDecimal ? getZeroInDecimal(convertedPrice).toFixed(2) : convertedPrice
    );

    if (formattedPrice?.indexOf('NaN') > -1) {
        return null;
    }

    return (
        <>
            {formattedPrice} {currency.symbol}
        </>
    );
};

export default CurrencyPrice;
